import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET, POST } from "../../../services/api";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

export const addEvaluation = createAsyncThunk(
    "evaluation/addEvaluation",
    async (modifiedData, { rejectWithValue }) => {
        try {            
            const response = await POST(
                "evaluation", 
                `${apiUrl.add_evaluations}`,
                modifiedData
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

export const fetchEvaluationDetails = createAsyncThunk(
    "evaluation/fetchEvaluationDetails",
    async (evaluationId, { rejectWithValue }) => {
        try {            
            const response = await GET(
                "evaluation", 
                `${apiUrl.evaluation_details}/${evaluationId}`
            );

            return response?.data;
        } catch (error) {
            console.log("##error", error?.detail?.message || error?.message || "Something Went Wrong");
            return rejectWithValue(
                error?.detail?.message || error?.message || "Something Went Wrong"
            );
        }
    }
);

const evaluationSlice = createSlice({
    name: "evaluation",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {}
});

export default evaluationSlice.reducer;